import { StrategicRecommendation } from 'types'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useState } from 'react'
import { IconButton } from 'blaze-ui/IconButton/IconButton'
import { Trash2 } from 'blaze-ui/icons'
import { Text } from 'blaze-ui/Text/Text'

interface Props {
  recommendation: StrategicRecommendation
  onChange: (id: number, recommendationText: string) => void
  onDelete: (id: number) => void
  isDisabled?: boolean
}

export const Row = ({ recommendation, onChange, onDelete, isDisabled = false }: Props) => {
  const canDebug = useFlipperFlag('brain_strategic_recommendations_debug')
  const [recommendationText, setRecommendationText] = useState(recommendation.recommendation)

  return (
    <tr>
      <td>
        <Input
          disabled={isDisabled}
          value={recommendationText}
          isTextarea
          name={`Recommendation ${recommendation.id}`}
          aria-label={`Recommendation ${recommendation.id}`}
          onChange={(e) => {
            setRecommendationText(e.target.value)
          }}
          onBlur={() => {
            onChange(recommendation.id, recommendationText)
          }}
          size="sm"
        />
      </td>
      <td>
        <Text variant="secondary" color="var(--dark-80)">
          {recommendation.reasoning}
        </Text>
      </td>
      {canDebug && <td>{recommendation.content}</td>}
      <td>
        <IconButton
          size="lg"
          variant="ghost"
          icon={Trash2}
          onPress={() => onDelete(recommendation.id)}
          aria-label={`Delete recommendation ${recommendation.id}`}
          isDisabled={isDisabled}
        />
      </td>
    </tr>
  )
}
